import { Container } from "@huub-web/ui/components/Container";
import { Columns } from "@huub-web/ui/components/Columns";

import type { TemplateRegistryDefinition } from "../types";
import {
  ExpenseCardTemplate,
  InputListTemplate,
  PaginatedListCardTemplate,
  DataCardTemplate,
  TableCardTemplate,
  ToggleInputTemplate,
  ToggledFormInputTemplate,
  type ToggledFormInputTemplateProps,
  ActionCardTemplate,
  SummaryListCardTemplate,
  UploadCardTemplate,
  CarouselTemplate,
  GraphCardTemplate,
  ButtonTemplate,
  LinkCardTemplate,
  ExpansionPanelTemplate,
  TabsTemplate,
  CardTemplate,
  FieldSetTemplate,
  FormTemplate,
  ColumnsTemplate,
  FormInputTemplate,
  FormRowGroupTemplate,
  type CardTemplateProps,
  type DataCardTemplateProps,
  type ExpenseCardTemplateProps,
  type FormInputTemplateProps,
  type FormTemplateProps,
  type FieldSetTemplateProps,
  type FormRowGroupTemplateProps,
  PaneTemplate,
  type PaneTemplateProps,
  type ToggleInputTemplateProps,
  type InputListTemplateProps,
  type TableCardTemplateProps,
  type PaginatedListCardTemplateProps,
  type ActionCardTemplateProps,
  type LinkCardTemplateProps,
  type SummaryListCardTemplateProps,
  type UploadCardTemplateProps,
  type CarouselTemplateProps,
  type ColumnsTemplateProps,
  type GraphCardTemplateProps,
  type ButtonTemplateProps,
  type ExpansionPanelTemplateProps,
  type TabsTemplateProps,
  type DocumentsUploadTemplateProps,
  DocumentsUploadTemplate,
  type DocumentPreFillFormTemplateProps,
  DocumentPreFillFormTemplate,
  type ModelEntryCardTemplateProps,
  ModelEntryCardTemplate,
  GridTemplate,
  type GridTemplateProps,
  type CenterTemplateProps,
  CenterTemplate,
  type AddCardTemplateProps,
  AddCardTemplate,
  FlowCardTemplate,
  type FlowCardTemplateProps,
  FormFlowTemplate,
  type FormFlowTemplateProps,
  type HeadingTemplateProps,
  HeadingTemplate,
  type SummaryCardTemplateProps,
  SummaryCardTemplate,
  type ActionTabsTemplateProps,
  ActionTabsTemplate,
  type MarkdownTemplateProps,
  MarkdownTemplate,
  ImageTemplate,
  type ImageTemplateProps,
  RulerTemplate,
  type RulerTemplateProps,
  SpacingTemplate,
  type SpacingTemplateProps,
  CardOverviewGridTemplate,
  type CardOverviewGridTemplateProps,
  ActionHubCardTemplate,
  type ActionHubCardTemplateProps,
  StepHubCardTemplate,
  type StepHubCardTemplateProps,
  MaximumMortgageHubCardTemplate,
  type MaximumMortgageHubCardTemplateProps,
  HouseAnalysisHubCardTemplate,
  type HouseAnalysisHubCardTemplateProps,
  MaximumMortgageWizardTemplate,
  type MaximumMortgageWizardTemplateProps,
  MaximumMortgageWizardResultTemplate,
  type MaximumMortgageWizardResultTemplateProps,
  HouseCardTemplate,
  type HouseCardTemplateProps,
  MessageTemplate,
  type MessageTemplateProps,
  ListTemplate,
  type ListTemplateProps,
  RealtorCardTemplate,
  type RealtorCardTemplateProps,
  HouseSearchCardTemplate,
  type HouseSearchCardTemplateProps,
  AddButtonTemplate,
  type AddButtonTemplateProps,
  OrientationHeadingTemplate,
  type OrientationHeadingTemplateProps,
  HubHeadingTemplate,
  type HubHeadingTemplateProps,
  MaximumMortgageHeadingTemplate,
  type MaximumMortgageHeadingTemplateProps,
  WinningBidTemplate,
  type WinningBidTemplateProps,
  WinningBidContentTemplate,
  type WinningBidContentTemplateProps,
  GalleryTemplate,
  type GalleryTemplateProps,
  HouseValueTrendTemplate,
  type HouseValueTrendTemplateProps,
  NeighbourhoodInformationTemplate,
  type NeighbourhoodInformationTemplateProps,
  AnalysisListTemplate,
  type AnalysisListTemplateProps,
  AnalysisLoaderTemplate,
  type AnalysisLoaderTemplateProps,
  HouseValueTrendContentTemplate,
  type HouseValueTrendContentTemplateProps,
  AnalysisListContentTemplate,
  type AnalysisListContentTemplateProps,
  AnalysisHeadingTemplate,
  type AnalysisHeadingTemplateProps,
  AnalysisHeaderTemplate,
  type AnalysisHeaderTemplateProps,
  AnalysisSummaryTemplate,
  type AnalysisSummaryTemplateProps,
  AnalysisObservationsTemplate,
  type AnalysisObservationsTemplateProps,
  AnalysisGalleryTemplate,
  type AnalysisGalleryTemplateProps,
  AnalysisNeighbourhoodTemplate,
  type AnalysisNeighbourhoodTemplateProps,
  AnalysisPropertyValueTemplate,
  type AnalysisPropertyValueTemplateProps,
  AnalysisSundialTemplate,
  type AnalysisSundialTemplateProps,
  ContentMenuTemplate,
  type ContentMenuTemplateProps,
  ContentMenuProviderTemplate,
  type ContentMenuProviderTemplateProps,
  SocketTemplate,
  type SocketTemplateProps,
  BidStrategyHeadingTemplate,
  type BidStrategyHeadingTemplateProps,
  KeyConsiderationsHeadingTemplate,
  type KeyConsiderationsHeadingTemplateProps,
  ViewingTipsTemplate,
  type ViewingTipsTemplateProps,
  ViewingTipsHeadingTemplate,
  type ViewingTipsHeadingTemplateProps,
  TipsCardTemplate,
  type TipsCardTemplateProps,
  ConsultationCardTemplate,
  type ConsultationCardTemplateProps,
  AdviceHeadingTemplate,
  type AdviceHeadingTemplateProps,
  OTDTemplate,
  type OTDTemplateProps,
  DocumentDownloadTemplate,
  type DocumentDownloadTemplateProps,
  AdvicePricesTemplate,
  type AdvicePricesTemplateProps,
  AnalysisTemplate,
  type AnalysisTemplateProps,
  AsyncTemplate,
  type AsyncTemplateProps,
  SectionTemplate,
  type SectionTemplateProps,
  type OcktoTemplateProps,
  QuickChatTemplate,
  type QuickChatTemplateProps,
  NextTaskCardTemplate,
  type NextTaskCardTemplateProps,
  DocumentViewerTemplate,
  type DocumentViewerTemplateProps,
  FAQListTemplate,
  type FAQListTemplateProps,
  FAQItemTemplate,
  type FAQItemTemplateProps,
  ModelCardTemplate,
  type ModelCardTemplateProps,
  ModelChildrenTemplate,
  type ModelChildrenTemplateProps,
  ModelsOverviewTemplate,
  type ModelsOverviewTemplateProps,
  ModelTemplate,
  type ModelTemplateProps,
  OCRFormUploadTemplate,
  type OCRFormUploadTemplateProps,
  OTDCardTemplate,
  type OTDCardTemplateProps,
  InterestRatesTemplate,
  type InterestRatesTemplateProps,
  InterestRatesHeadingTemplate,
  type InterestRatesHeadingTemplateProps,
  DocumentsHeadingTemplate,
  type DocumentsHeadingTemplateProps,
  OcktoCardTemplate,
  type OcktoCardTemplateProps,
  AssessmentTestTemplate,
  type AssessmentTestTemplateProps,
  AssessmentTestCardTemplate,
  type AssessmentTestCardTemplateProps,
} from "../templates";

/**
 * The TemplateRegistry is a mapping of template keys to template definitions.
 */
export const TemplateRegistry: TemplateRegistryDefinition = {
  card: {
    $propsType: {} as CardTemplateProps,
    template: CardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  /**
   * @deprecated 💀
   */
  actionTabs: {
    $propsType: {} as ActionTabsTemplateProps,
    template: ActionTabsTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container stretch>{children}</Container> : children,
  },
  dataCard: {
    $propsType: {} as DataCardTemplateProps,
    template: DataCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  expenseCard: {
    $propsType: {} as ExpenseCardTemplateProps,
    template: ExpenseCardTemplate,
    wrap: (level, children) =>
      level === 0 ? (
        <Container>
          <Columns>{children}</Columns>
        </Container>
      ) : (
        children
      ),
  },
  formInput: {
    $propsType: {} as FormInputTemplateProps,
    template: FormInputTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  form: {
    $propsType: {} as FormTemplateProps,
    template: FormTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  formRowGroup: {
    $propsType: {} as FormRowGroupTemplateProps,
    template: FormRowGroupTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  pane: {
    $propsType: {} as PaneTemplateProps,
    template: PaneTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  fieldSet: {
    $propsType: {} as FieldSetTemplateProps,
    template: FieldSetTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  toggleInput: {
    $propsType: {} as ToggleInputTemplateProps,
    template: ToggleInputTemplate,
    wrap: (level, children) =>
      level === 0 ? (
        <Container>
          <Columns>{children}</Columns>
        </Container>
      ) : (
        children
      ),
  },
  toggledFormInput: {
    $propsType: {} as ToggledFormInputTemplateProps,
    template: ToggledFormInputTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  inputList: {
    $propsType: {} as InputListTemplateProps,
    template: InputListTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  tableCard: {
    $propsType: {} as TableCardTemplateProps,
    template: TableCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  paginatedListCard: {
    $propsType: {} as PaginatedListCardTemplateProps,
    template: PaginatedListCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  actionCard: {
    $propsType: {} as ActionCardTemplateProps,
    template: ActionCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  addCard: {
    $propsType: {} as AddCardTemplateProps,
    template: AddCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  linkCard: {
    $propsType: {} as LinkCardTemplateProps,
    template: LinkCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  summaryListCard: {
    $propsType: {} as SummaryListCardTemplateProps,
    template: SummaryListCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  summaryCard: {
    $propsType: {} as SummaryCardTemplateProps,
    template: SummaryCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  uploadCard: {
    $propsType: {} as UploadCardTemplateProps,
    template: UploadCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  documentsUpload: {
    $propsType: {} as DocumentsUploadTemplateProps,
    template: DocumentsUploadTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  /**
   * @deprecated 💀
   */
  documentPreFillForm: {
    $propsType: {} as DocumentPreFillFormTemplateProps,
    template: DocumentPreFillFormTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  documentViewer: {
    $propsType: {} as DocumentViewerTemplateProps,
    template: DocumentViewerTemplate,
    wrap: (_level, children) => children,
  },
  carousel: {
    $propsType: {} as CarouselTemplateProps,
    template: CarouselTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        console.error("Carousel can only be used at the top level");
        return null;
      }
      return children;
    },
  },
  columns: {
    $propsType: {} as ColumnsTemplateProps,
    template: ColumnsTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  graphCard: {
    $propsType: {} as GraphCardTemplateProps,
    template: GraphCardTemplate,
    wrap: (level, children) =>
      level === 0 ? (
        <Container>
          <Columns>{children}</Columns>
        </Container>
      ) : (
        children
      ),
  },
  houseCard: {
    $propsType: {} as HouseCardTemplateProps,
    template: HouseCardTemplate,
    wrap: (level, children) =>
      level === 0 ? (
        <Container>
          <Columns>{children}</Columns>
        </Container>
      ) : (
        children
      ),
  },
  assessmentTest: {
    $propsType: {} as AssessmentTestTemplateProps,
    template: AssessmentTestTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  assessmentTestCard: {
    $propsType: {} as AssessmentTestCardTemplateProps,
    template: AssessmentTestCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  button: {
    $propsType: {} as ButtonTemplateProps,
    template: ButtonTemplate,
    wrap: (level, children, data) => {
      const { align } = data as ButtonTemplateProps;

      return level === 0 ? (
        <Container>
          <Columns>{children}</Columns>
        </Container>
      ) : align === "right" ? (
        children
      ) : (
        <div>{children}</div>
      );
    },
  },
  expansionPanel: {
    $propsType: {} as ExpansionPanelTemplateProps,
    template: ExpansionPanelTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  tabs: {
    $propsType: {} as TabsTemplateProps,
    template: TabsTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  modelEntryCard: {
    $propsType: {} as ModelEntryCardTemplateProps,
    template: ModelEntryCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Columns>{children}</Columns> : children,
  },
  grid: {
    $propsType: {} as GridTemplateProps,
    template: GridTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  center: {
    $propsType: {} as CenterTemplateProps,
    template: CenterTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error("Center can only be used at the top level");
      }
      return children;
    },
  },
  flowCard: {
    $propsType: {} as FlowCardTemplateProps,
    template: FlowCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  formFlow: {
    $propsType: {} as FormFlowTemplateProps,
    template: FormFlowTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  heading: {
    $propsType: {} as HeadingTemplateProps,
    template: HeadingTemplate,
    wrap: (level, children) => {
      if (level === 0) {
        // if (data.variant === "main") {
        //   return <Container size="s">{children}</Container>;
        // }
        return <Container>{children}</Container>;
      }
      return children;
    },
  },
  markdown: {
    $propsType: {} as MarkdownTemplateProps,
    template: MarkdownTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  image: {
    $propsType: {} as ImageTemplateProps,
    template: ImageTemplate,
    wrap: (level, children) =>
      level === 0 ? <Columns>{children}</Columns> : children,
  },
  ruler: {
    $propsType: {} as RulerTemplateProps,
    template: RulerTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  spacing: {
    $propsType: {} as SpacingTemplateProps,
    template: SpacingTemplate,
    wrap: (_level, children) => children,
  },
  cardOverviewGrid: {
    $propsType: {} as CardOverviewGridTemplateProps,
    template: CardOverviewGridTemplate,
  },
  actionHubCard: {
    $propsType: {} as ActionHubCardTemplateProps,
    template: ActionHubCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  stepHubCard: {
    $propsType: {} as StepHubCardTemplateProps,
    template: StepHubCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  maximumMortgageHubCard: {
    $propsType: {} as MaximumMortgageHubCardTemplateProps,
    template: MaximumMortgageHubCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  houseAnalysisHubCard: {
    $propsType: {} as HouseAnalysisHubCardTemplateProps,
    template: HouseAnalysisHubCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  maximumMortgageWizard: {
    $propsType: {} as MaximumMortgageWizardTemplateProps,
    template: MaximumMortgageWizardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  maximumMortgageWizardResult: {
    $propsType: {} as MaximumMortgageWizardResultTemplateProps,
    template: MaximumMortgageWizardResultTemplate,
    wrap: (_level, children) => children,
  },
  message: {
    $propsType: {} as MessageTemplateProps,
    template: MessageTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  list: {
    $propsType: {} as ListTemplateProps,
    template: ListTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  tipsCard: {
    $propsType: {} as TipsCardTemplateProps,
    template: TipsCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  /**
   * @deprecated 💀
   */
  realtorCard: {
    $propsType: {} as RealtorCardTemplateProps,
    template: RealtorCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  houseSearchCard: {
    $propsType: {} as HouseSearchCardTemplateProps,
    template: HouseSearchCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  addButton: {
    $propsType: {} as AddButtonTemplateProps,
    template: AddButtonTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  orientationHeading: {
    $propsType: {} as OrientationHeadingTemplateProps,
    template: OrientationHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  hubHeading: {
    $propsType: {} as HubHeadingTemplateProps,
    template: HubHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  maximumMortgageHeading: {
    $propsType: {} as MaximumMortgageHeadingTemplateProps,
    template: MaximumMortgageHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  winningBid: {
    $propsType: {} as WinningBidTemplateProps,
    template: WinningBidTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  winningBidContent: {
    $propsType: {} as WinningBidContentTemplateProps,
    template: WinningBidContentTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  gallery: {
    $propsType: {} as GalleryTemplateProps,
    template: GalleryTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  houseValueTrend: {
    $propsType: {} as HouseValueTrendTemplateProps,
    template: HouseValueTrendTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  neighbourhoodInformation: {
    $propsType: {} as NeighbourhoodInformationTemplateProps,
    template: NeighbourhoodInformationTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  analysisList: {
    $propsType: {} as AnalysisListTemplateProps,
    template: AnalysisListTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  analysisLoader: {
    $propsType: {} as AnalysisLoaderTemplateProps,
    template: AnalysisLoaderTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  houseValueTrendContent: {
    $propsType: {} as HouseValueTrendContentTemplateProps,
    template: HouseValueTrendContentTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  analysisListContent: {
    $propsType: {} as AnalysisListContentTemplateProps,
    template: AnalysisListContentTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  analysisHeading: {
    $propsType: {} as AnalysisHeadingTemplateProps,
    template: AnalysisHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  analysisHeader: {
    $propsType: {} as AnalysisHeaderTemplateProps,
    template: AnalysisHeaderTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  analysisSummary: {
    $propsType: {} as AnalysisSummaryTemplateProps,
    template: AnalysisSummaryTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error("AnalysisSummary can only be used at the top level");
      }
      return children;
    },
  },
  analysisObservations: {
    $propsType: {} as AnalysisObservationsTemplateProps,
    template: AnalysisObservationsTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error(
          "AnalysisObservations can only be used at the top level",
        );
      }
      return children;
    },
  },
  analysisGallery: {
    $propsType: {} as AnalysisGalleryTemplateProps,
    template: AnalysisGalleryTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error("AnalysisGallery can only be used at the top level");
      }
      return children;
    },
  },
  analysisNeighbourhood: {
    $propsType: {} as AnalysisNeighbourhoodTemplateProps,
    template: AnalysisNeighbourhoodTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error(
          "AnalysisNeighbourhood can only be used at the top level",
        );
      }
      return children;
    },
  },
  analysisPropertyValue: {
    $propsType: {} as AnalysisPropertyValueTemplateProps,
    template: AnalysisPropertyValueTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error(
          "AnalysisPropertyValue can only be used at the top level",
        );
      }
      return children;
    },
  },
  analysisSundial: {
    $propsType: {} as AnalysisSundialTemplateProps,
    template: AnalysisSundialTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error(
          "AnalysisPropertyValue can only be used at the top level",
        );
      }
      return children;
    },
  },
  contentMenu: {
    $propsType: {} as ContentMenuTemplateProps,
    template: ContentMenuTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error(
          "ContentMenu can only be used at the top level and in a ContentMenuProviderTemplate",
        );
      }
      return children;
    },
  },
  contentMenuProvider: {
    $propsType: {} as ContentMenuProviderTemplateProps,
    template: ContentMenuProviderTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error(
          "ContentMenuProvider can only be used at the top level",
        );
      }
      return children;
    },
  },
  socket: {
    $propsType: {} as SocketTemplateProps,
    template: SocketTemplate,
    wrap: (level, children, props) => {
      if (level === 0 && props.level !== 0) {
        return <Container>{children}</Container>;
      }
      return children;
    },
  },
  bidStrategyHeading: {
    $propsType: {} as BidStrategyHeadingTemplateProps,
    template: BidStrategyHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  /**
   * @deprecated 💀
   */
  keyConsiderationsHeading: {
    $propsType: {} as KeyConsiderationsHeadingTemplateProps,
    template: KeyConsiderationsHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  viewingTips: {
    $propsType: {} as ViewingTipsTemplateProps,
    template: ViewingTipsTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  viewingTipsHeading: {
    $propsType: {} as ViewingTipsHeadingTemplateProps,
    template: ViewingTipsHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  advisorDiscuss: {
    $propsType: {} as ConsultationCardTemplateProps,
    template: ConsultationCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  adviceHeading: {
    $propsType: {} as AdviceHeadingTemplateProps,
    template: AdviceHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  otd: {
    $propsType: {} as OTDTemplateProps,
    template: OTDTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  documentDownload: {
    $propsType: {} as DocumentDownloadTemplateProps,
    template: DocumentDownloadTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  advicePrices: {
    $propsType: {} as AdvicePricesTemplateProps,
    template: AdvicePricesTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  analysis: {
    $propsType: {} as AnalysisTemplateProps,
    template: AnalysisTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error("Analysis can only be used at the top level");
      }
      return children;
    },
  },
  async: {
    $propsType: {} as AsyncTemplateProps,
    template: AsyncTemplate,
    wrap: (_, children, { level: asyncLevel }) =>
      asyncLevel === 0 ? children : <Container>{children}</Container>,
  },
  section: {
    $propsType: {} as SectionTemplateProps,
    template: SectionTemplate,
    wrap: (level, children) => {
      if (level > 0) {
        throw new Error("Section can only be used at the top level");
      }
      return children;
    },
  },
  /**
   * Backward-compat shim: renders OcktoCardTemplate with old OcktoTemplateProps.
   * Uses OcktoTemplateProps ($propsType) for TemplateParser type inference, but
   * the component receives OcktoCardTemplateProps at runtime — missing optional
   * fields (buttonValue, modalTitle, etc.) fall through to defaults.
   * Uses Container wrapper (not Columns) to preserve standalone layout during
   * the deploy transition before backend migrates to "ocktoCard".
   * Remove once backend fully uses "ocktoCard".
   */
  ockto: {
    $propsType: {} as OcktoTemplateProps,
    template: OcktoCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  ocktoCard: {
    $propsType: {} as OcktoCardTemplateProps,
    template: OcktoCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Columns>{children}</Columns> : children,
  },
  quickChat: {
    $propsType: {} as QuickChatTemplateProps,
    template: QuickChatTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  nextTaskCard: {
    $propsType: {} as NextTaskCardTemplateProps,
    template: NextTaskCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  faqList: {
    $propsType: {} as FAQListTemplateProps,
    template: FAQListTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  faqItem: {
    $propsType: {} as FAQItemTemplateProps,
    template: FAQItemTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  model: {
    $propsType: {} as ModelTemplateProps,
    template: ModelTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  modelCard: {
    $propsType: {} as ModelCardTemplateProps,
    template: ModelCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  modelChildren: {
    $propsType: {} as ModelChildrenTemplateProps,
    template: ModelChildrenTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  modelsOverview: {
    $propsType: {} as ModelsOverviewTemplateProps,
    template: ModelsOverviewTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  ocrFormUpload: {
    $propsType: {} as OCRFormUploadTemplateProps,
    template: OCRFormUploadTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  otdCard: {
    $propsType: {} as OTDCardTemplateProps,
    template: OTDCardTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  interestRates: {
    $propsType: {} as InterestRatesTemplateProps,
    template: InterestRatesTemplate,
    wrap: (_level, children) => children,
  },
  interestRatesHeading: {
    $propsType: {} as InterestRatesHeadingTemplateProps,
    template: InterestRatesHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
  documentsHeading: {
    $propsType: {} as DocumentsHeadingTemplateProps,
    template: DocumentsHeadingTemplate,
    wrap: (level, children) =>
      level === 0 ? <Container>{children}</Container> : children,
  },
};
